import axios from "axios";

/**
 * This is the API call that loads a single media item.
 * ToDo: Do I need the pageParam?
 */
export const retrieveMediaItem = async (
  userId,
  mediaId
) => {
  let response;
  //const encoded = encodeURIComponent(lastEvaluatedKey);

  const encodedUserId = userId.replace("#", "%23");
  const endpoint = `https://${process.env.REACT_APP_DOMAIN}/api/getmediaitem?m=${mediaId}&u=${encodedUserId}`;

  response = await axios.get(endpoint);
  if (response === null) {
    return { data: [], lastEvaluatedKey: undefined };
  }
 // lastEvaluatedKey = response.data.lastEvaluatedKey;
  //console.log(`retrieveMediaItemResponse=${response.data}`)
  return response.data;
};
